<template>
    <div>
        <div class="common-form">规格明细</div>
        <div class="spec-box">
            <!--添加-->
            <el-input
                    ref="inputName"
                    placeholder="请输入明细名称 回车保存"
                    v-model="specValueName"
                    clearable
                    @keyup.enter.native="add">
            </el-input>

            <div class="tag-box">
                <el-tag
                    v-for="tag in specDetails"
                    :key="tag.spec_value"
                    effect="dark"
                    closable
                    disable-transitions
                    @close="specValueDel(tag)">
                    {{tag.spec_value}}
                </el-tag>
            </div>

        </div>
    </div>
</template>

<script>
    import ProductApi from '@/api/product.js';

    export default {
        name: "SpecDetails",
        data() {
            return {
                addShow: false,
                specDetails: [],
                specId: '',
                specValueName: '',
            };
        },
        create() {
            this.$nextTick(() => {
                this.$refs.inputName.focus()
            })
        },
        methods: {
            // 规格值列表
            getSpecValue(spec_id) {
                let self = this

                self.specId = spec_id
                ProductApi.getSpecValue({spec_id: self.specId}, true)
                    .then(res => {
                        self.specDetails = res.data.list
                    })
                    .catch(error => {

                    });
            },

            // 添加规格值
            add() {
                let self = this;
                if (self.specValueName === '') {
                    self.$message('请填写规则值名')
                    return false
                }
                const Params = {
                    spec_id: self.specId,
                    spec_value: self.specValueName,
                }

                ProductApi.addSpecValue(Params)
                    .then(res => {
                        self.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        self.specValueName = ''
                        self.getSpecValue(self.specId)
                    }).catch(error => {

                });
            },

            // 删除规格值
            specValueDel(row) {
                let self = this
                self.$confirm('删除后不可恢复，确认删除该规格值吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    ProductApi.specValueDel({
                        spec_value_id: row.spec_value_id
                    }).then(res => {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        self.getSpecValue(self.specId)
                    });
                }).catch(error => {

                });

            },
        }

    }
</script>

<style scoped>
    .spec-box {
        padding: 20px;
        background-color: #F0F8FF;
        margin: 10px;
    }

    .common-form {
        position: relative;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 700;
        margin: 10px 0;
        border-bottom: 1px solid #bababa;
    }

    .common-form:before {
        margin-left: 10px;
    }

    .tag-box {
        padding-top: 20px;
    }

    .tag-box .el-tag + .el-tag {
        margin-left: 10px
    }
</style>



// WEBPACK FOOTER //
// src/views/product/spec/SpecDetails.vue